<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_ order">保费试算</div>
          <div class="cutleft_ policy">险种信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="20">
            <div class="form_item" style="justify-content: flex-start;">
              <label>保障期限</label>
              <div class="pre-box">
                <div class="">
                  <a-radio-group :disabled="disabledAll" v-model="guapre" @change="e => changeData(e.target.value, 'BZQJa')">
                    <a-radio v-for="item in guarantPre" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
                  </a-radio-group>
                </div>
              </div>
            </div>
            <div class="policy_none">
              <a @click="$tools.downloadFile(fileCodeContent.occ_url)">职业类别表</a>
            </div>
            <div class="form_item policy_none">
              <label>投保职业</label>
              <div class="right_">
                <div class="check_item s_input" v-for="item in occupationNumberList" :key="item.occupationKind">
                  <label for>
                    {{ item.occupationKind.toString().indexOf('类') > -1 ? item.occupationKind : item.occupationKind + '类' }}
                  </label>
                  <a-input-number :disabled="disabledAll" :min="0" v-model="item.personNum" @change="value => changeData(value, 'TBZYa')"></a-input-number>
                  <span>人</span>
                </div>
                <div class="check_item">
                  <span>总人数：{{ totalNumber }}人</span>
                </div>
              </div>
            </div>
            <div class="form_item policy_none" style="justify-content: start;margin-bottom: 0px">
              <a-form-item style="width:85%" :label-col="{ span: 4 }" label="行业类别">
                <a-cascader
                  :disabled="disabledAll"
                  :options="industryList"
                  :field-names="{ label: 'text' }"
                  :show-search="{ filter }"
                  @change="(value, label) => changeData(value, 'HYLX', label)"
                  :fieldNames="{
                    label: 'text',
                    value: 'value',
                    children: 'children'
                  }"
                  v-decorator="['HYLXArr', { rules: [{ required: true, message: '请选择' }] }]"
                  placeholder="请选择行业"
                />
              </a-form-item>
            </div>
          </a-col>
          <a-col :span="4" class="calRight_ policy_none">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ premiumSum }}</div>
          </a-col>
        </a-row>
      </div>
      <div class="risk_">
        <p class="p-header">主险</p>
        <!-- 意外身故及伤残 -->
        <div class="form_item">
          <label>意外身故及伤残</label>
          <div class="right_">
            <a-select placeholder="请选择" style="width: 300px" :disabled="disabledAll" class="select_" @change="value => changeData(value, 'SWCJ')" v-model="countData.SWCJ">
              <a-select-option v-for="item in SWCJOptions" :key="item.value + 'SWCJ'" :value="item.value"> {{ item.name }}</a-select-option>
            </a-select>
          </div>
        </div>
        <p class="p-header">附加险</p>
        <div class="flex_">
          <!-- 意外医疗费用 -->
          <div class="form_item">
            <label>意外医疗费用</label>
            <div class="right_">
              <a-select :disabled="disabledAll" placeholder="请选择" style="width: 300px" class="select_" v-model="countData.YLFY" @change="value => changeData(value, 'YLFY')">
                <a-select-option v-for="(item, index) in YLFYOptions" :key="item.value + 'YLFY' + index" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 意外医疗费用免赔额 -->
          <div class="form_item">
            <label>意外医疗费用免赔额</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" class="select_" :disabled="countData.YLFY == 0 || disabledAll" v-model="countData.ZFYF" @change="value => changeData(value, 'ZFYF')">
                <a-select-option v-for="(item, index) in ZFYFOptions" :key="item.value + 'ZFYF' + index" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 意外医疗费用赔付比例 -->
          <div class="form_item">
            <label>意外医疗费用赔付比例</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" class="select_" :disabled="countData.YLFY == 0 || disabledAll" v-model="countData.ZYJT" @change="value => changeData(value, 'ZYJT')">
                <a-select-option v-for="item in ZYJTOptions" :key="item.value + 'ZYJT'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!--意外每日住院津贴 -->
          <div class="form_item">
            <label>意外每日住院津贴</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" class="select_" :disabled="disabledAll" v-model="countData.KZSC" @change="value => changeData(value, 'KZSC')">
                <a-select-option v-for="item in KZSCOptions" :key="item.value + 'KZSC'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 民航客运飞机意外身故及伤残 -->
          <div class="form_item">
            <label>民航客运飞机意外身故及伤残</label>
            <div class="right_">
              <a-select placeholder="请选择" :disabled="disabledAll" style="width: 300px" class="select_" v-model="countData.YCXSCa" @change="value => changeData(value, 'YCXSCa')">
                <a-select-option v-for="item in oneSCOptions" :key="item.value + 'YCXSCa'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 火车意外身故及伤残 -->
          <div class="form_item">
            <label>火车意外身故及伤残</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" :disabled="disabledAll" class="select_" v-model="countData.SHHLa" @change="value => changeData(value, 'SHHLa')">
                <a-select-option v-for="item in SHHLOptions" :key="item.value + 'SHHLa'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 轮船意外身故及伤残 -->
          <div class="form_item">
            <label>轮船意外身故及伤残</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" :disabled="disabledAll" class="select_" v-model="countData.KYLCYW" @change="value => changeData(value, 'KYLCYW')">
                <a-select-option v-for="item in KYLCYWOptions" :key="item.value + 'KYLCYW'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 公共汽车意外身故及伤残 -->
          <div class="form_item">
            <label>公共汽车意外身故及伤残</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" :disabled="disabledAll" class="select_" v-model="countData.KYQCYW" @change="value => changeData(value, 'KYQCYW')">
                <a-select-option v-for="item in KYQCYWOptions" :key="item.value + 'KYQCYW'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="btn_list">
          <a-button class="calBtn_" type="primary" @click="countPremiumSum" :disabled="disabledAll">刷新试算</a-button>
          <a-button style="margin-bottom: 50px" class="calBtn_" type="primary" v-if="!agreementRead" @click="goplicy" :disabled="disabledAll">去投保</a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>
<script>
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
let DATA = require('../data').default;
export default {
  mixins: [riskinfoMixin],
  data() {
    return {
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      guapre: 1,
      //保障期间
      guarantPre: DATA.guarantPre,
      //投保职业及人数
      occupationNumberList: DATA.occupationNumberList,
      premiumSum: 0, //总保费
      HYLXArr: [], //行业类型
      // 测算要提交的数据
      countData: {
        BZQJa: 1, //保障期间?
        TBZYa: 0, //投保职业?
        HYLX: '', //行业类型
        SWCJ: 100000, //意外身故及伤残 1
        YLFY: 10000, //意外医疗费用 2
        ZFYF: 0, //意外医疗费用免赔额 3
        ZYJT: 100, //意外医疗费用赔付比例 4
        KZSC: 0, //意外每日住院津贴 5
        YCXSCa: 0, //民航客运飞机意外身故及伤残 6
        SHHLa: 0, //火车意外身故及伤残 7
        KYLCYW: 0, //轮船意外身故及伤残 8
        KYQCYW: 0 //公共汽车意外身故及伤残 9
      },
      //提交data
      data: {
        riskInfos: [],
        salPolicy: {
          productCode: '', //产品code
          planCode: '', //plancode
          bracket: 12 //保费期限
        },
        salPolicyExt: {
          isworkheightinvolved: 2
        },
        salPolicyHolder: {
          addfifty: '2', // 测算类型
          industrycode: '' //行业code
        },
        premiumBaseDtoList: [] //人数
      },
      creator: '1',
      productCode: '',
      plan: '',
      exist456: false // 含4,5,6类职业
    };
  },
  computed: {
    industryList() {
      return window.aszxtyOccDatas;
    },
    // 民航客运飞机意外身故及伤残
    oneSCOptions() {
      let obj = {
        value: 0,
        name: '不附加'
      };
      let option = this.$lodash.cloneDeep(this.SWCJOptions);
      option.unshift(obj);
      return option.filter(e => e.value <= this.countData.SWCJ);
    },
    // 火车意外身故及伤残
    SHHLOptions() {
      let obj = {
        value: 0,
        name: '不附加'
      };
      let option = this.$lodash.cloneDeep(this.SWCJOptions);
      option.unshift(obj);
      return option.filter(e => e.value <= this.countData.SWCJ);
    },
    //轮船意外身故及伤残
    KYLCYWOptions() {
      let obj = {
        value: 0,
        name: '不附加'
      };
      let option = this.$lodash.cloneDeep(this.SWCJOptions);
      option.unshift(obj);
      return option.filter(e => e.value <= this.countData.SWCJ);
    },
    //公共汽车意外身故及伤残
    KYQCYWOptions() {
      let obj = {
        value: 0,
        name: '不附加'
      };
      let option = this.$lodash.cloneDeep(this.SWCJOptions);
      option.unshift(obj);
      return option.filter(e => e.value <= this.countData.SWCJ);
    },
    // 意外每日住院津贴
    KZSCOptions() {
      this.countData.KZSC = this.countData.KZSC || 0;
      let KZSCOptions = [
        {
          value: 0,
          name: '不附加'
        },
        {
          value: 50,
          name: '50元/天'
        },
        {
          value: 100,
          name: '100元/天'
        },
        {
          value: 150,
          name: '150元/天'
        }
      ];
      if (this.occupationNumberList[5].personNum + this.occupationNumberList[4].personNum) {
        return KZSCOptions.filter(item => item.value <= 100);
      } else {
        return KZSCOptions;
      }
    },
    // 意外身故及伤残
    SWCJOptions() {
      let Options = [
        {
          value: 100000,
          name: '10万'
        },
        {
          value: 200000,
          name: '20万'
        },
        {
          value: 300000,
          name: '30万'
        },
        {
          value: 400000,
          name: '40万'
        },
        {
          value: 500000,
          name: '50万'
        },
        {
          value: 600000,
          name: '60万'
        },
        {
          value: 700000,
          name: '70万'
        },
        {
          value: 800000,
          name: '80万'
        },
        {
          value: 900000,
          name: '90万'
        },
        {
          value: 1000000,
          name: '100万'
        }
      ];
			// 4-6类 最高保额60w
      if (this.occupationNumberList[3].personNum + this.occupationNumberList[4].personNum + this.occupationNumberList[5].personNum) {
        return Options.filter(item => item.value <= 600000);
      } else {
        return Options;
      }
    },
    // 扩展社保范围外医疗费用（含甲乙丙类自付和自费）
    ZFYFOptions() {
      let Options = [
        //意外医疗费用免赔额(即保司系统自费药)选择框
        {
          value: 0,
          name: '0'
        },
        {
          value: 100,
          name: '每次事故RMB100'
        },
        {
          value: 200,
          name: '每次事故RMB200'
        }
      ];
      return Options;
    },
    // 意外医疗费用
    YLFYOptions() {
      if (this.countData.YLFY > this.countData.SWCJ * 0.1) {
        this.countData.YLFY = 10000;
      }
      let option = [
        // {
        //   value: 0,
        //   name: '不附加'
        // },
        {
          value: 10000,
          name: '1万'
        },
        {
          value: 20000,
          name: '2万'
        },
        {
          value: 30000,
          name: '3万'
        },
        {
          value: 40000,
          name: '4万'
        },
        {
          value: 50000,
          name: '5万'
        },
        {
          value: 60000,
          name: '6万'
        },
        {
          value: 70000,
          name: '7万'
        },
        {
          value: 80000,
          name: '8万'
        },
        {
          value: 90000,
          name: '9万'
        },
        {
          value: 100000,
          name: '10万'
        },
        {
          value: 110000,
          name: '11万'
        },
        {
          value: 120000,
          name: '12万'
        },
        {
          value: 130000,
          name: '13万'
        },
        {
          value: 140000,
          name: '14万'
        },
        {
          value: 150000,
          name: '15万'
        },
        {
          value: 160000,
          name: '16万'
        },
        {
          value: 170000,
          name: '17万'
        },
        {
          value: 180000,
          name: '18万'
        },
        {
          value: 190000,
          name: '19万'
        },
        {
          value: 200000,
          name: '20万'
        }
      ];
      return option.filter(item => item.value <= this.countData.SWCJ * 0.1);
    },
    // 意外医疗费用赔付比例
    ZYJTOptions() {
      let ZYJTOptions = [
        {
          value: 70,
          name: '70%'
        },
        {
          value: 90,
          name: '90%'
        },
        {
          value: 100,
          name: '100%'
        }
      ];
      return ZYJTOptions;
    },
    // 选的总投保人数
    totalNumber() {
      let num = 0;
      this.occupationNumberList.forEach(e => {
        num += Number(e.personNum);
      });
      return parseInt(num);
    },
    // 险种的数组
    riskInfos() {
      let infos = [
        {
          riskCode: 'disabilityByAccident', //意外身故及伤残
          amount: this.countData.SWCJ,
          riskName: `意外身故及伤残`,
          riskAmountDesc: this.countData.SWCJ
        },
        {
          riskCode: 'accidentMedicalExpenses', //意外医疗费用
          amount: this.countData.YLFY,
          riskName: `意外医疗费用`,
          riskAmountDesc: this.countData.YLFY
        },
        {
          riskCode: 'accidentMedicalExcess', //意外医疗费用免赔额
          amount: this.countData.ZFYF,
          riskName: `意外医疗费用免赔额`,
          riskAmountDesc: this.countData.ZFYF
        },
        {
          riskCode: 'accidentMedicalratio', //意外医疗费用赔付比例
          amount: this.countData.YLFY ? this.countData.ZYJT : 0,
          riskName: `意外医疗费用赔付比例`,
          riskAmountDesc: this.countData.YLFY ? this.countData.ZYJT + '%' : 0
        },
        {
          riskCode: 'allowanceByAccident', //意外每日住院津贴
          amount: this.countData.KZSC,
          riskName: `意外每日住院津贴`,
          riskAmountDesc: this.countData.KZSC
        },
        {
          riskCode: 'accidentDisabilityByPlane', //民航客运飞机意外身故及伤残
          amount: this.countData.YCXSCa,
          riskName: `民航客运飞机意外身故及伤残`,
          riskAmountDesc: this.countData.YCXSCa
        },
        {
          riskCode: 'accidentDisabilityByTrain', //火车意外身故及伤残
          amount: this.countData.SHHLa,
          riskName: `火车意外身故及伤残`,
          riskAmountDesc: this.countData.SHHLa
        },
        {
          riskCode: 'accidentDisabilityByShip', //轮船意外身故及伤残
          amount: this.countData.KYLCYW,
          riskName: `轮船意外身故及伤残`,
          riskAmountDesc: this.countData.KYLCYW
        },
        {
          riskCode: 'accidentDisabilityByCar', //公共汽车意外身故及伤残
          amount: this.countData.KYQCYW,
          riskName: `公共汽车意外身故及伤残`,
          riskAmountDesc: this.countData.KYQCYW
        }
      ];
      return infos;
    }
  },
  watch: {
    'countData.YLFY'(val) {
      if (!val) {
        this.countData.ZFYF = 0;
      }
    }
  },
  props: ['disabledAll'],
  mounted() {
    this.$bus.$on('busRiskInfos', data => {
      //响应险种信息
      let obj = this.$lodash.cloneDeep(this.countData);
      let hycode = data.salPolicyHolder.industrycode;
      if (hycode) {
        this.form.setFieldsValue({
          HYLXArr: [hycode.slice(0, 1), hycode.slice(0, 3), hycode]
        });
        obj.HYLX = hycode;
      }
      data.riskInfos.forEach(e => {
        if (e.riskCode == 'disabilityByAccident') obj.SWCJ = e.amount;
        if (e.riskCode == 'accidentMedicalExpenses') obj.YLFY = e.amount;
        if (e.riskCode == 'accidentMedicalExcess') obj.ZFYF = e.amount;
        if (e.riskCode == 'accidentMedicalratio') obj.ZYJT = e.amount;
        if (e.riskCode == 'allowanceByAccident') obj.KZSC = e.amount;
        if (e.riskCode == 'accidentDisabilityByPlane') obj.YCXSCa = e.amount;
        if (e.riskCode == 'accidentDisabilityByTrain') obj.SHHLa = e.amount;
        if (e.riskCode == 'accidentDisabilityByShip') obj.KYLCYW = e.amount;
        if (e.riskCode == 'accidentDisabilityByCar') obj.KYQCYW = e.amount;
      });

      this.countData = { ...obj };
      console.log(this.countData);
    });
    this.$bus.$emit('onRiskInfosSWCJ', this.countData.SWCJ);
    this.$bus.$emit('onRiskInfosKZSC', this.countData.KZSC);
    this.$bus.$on('dataList', data => {
      data.forEach(e => {
        e.occupationKind = e.occupationKind.toString().indexOf('类') > -1 ? Number(e.occupationKind.slice(0, 1)) : Number(e.occupationKind);
      });
      this.occupationNumberList = data;
      this.changeData();
    });
  },
  beforeDestroy() {
    this.$bus.$off('busRiskInfos');
    this.$bus.$off('dataList');
  },
  methods: {
    // 去投保
    goplicy() {
      this.$store.commit('setAgreement', true);
    },
    handleChange(value, type) {
      this.countData[type] = value;
    },
    filter(inputValue, path) {
      return path.some(option => {
        return (
          option.text
            .toLowerCase()
            .toString()
            .indexOf(inputValue.toLowerCase()) > -1
        );
      });
    },
    //初始化扩展社保范围外医疗费用
    reactdata() {
      if (this.countData.YLFY == 0) {
        this.countData.ZFYF = 0;
      }
      if (this.occupationNumberList[3].personNum || this.occupationNumberList[4].personNum) {
        this.countData.ZFYF = 0;
      }
    },
    // 改变试算的数据
    changeData(value, param) {
      if (param == 'HYLX') {
        this.countData[param] = value[3];
        this.HYLXArr = value;
      }
      if (param == 'BZQJa') {
        this.countData[param] = value;
      }
      let exist456 = false;
      let premiumBaseDtoList = this.occupationNumberList.filter(item => {
        let valid = item.personNum > 0;
        // 判断4-6类职业是否有投保人数
        if (valid && (item.occupationKind === 4 || item.occupationKind === 5 || item.occupationKind === 6)) {
          exist456 = true;
        }
        return valid;
      });
      this.exist456 = exist456;
      this.data = {
        riskInfos: this.riskInfos.filter(item => item.amount > 0), //险种信息
        // riskInfos: this.riskInfos,
        salPolicy: {
          planCode: this.plan || this.productCode,
          creator: this.creator,
          productCode: this.productCode, //产品code
          bracket: this.countData.BZQJa.toString(), //保费期限
          groupSize: this.totalNumber
        },
        salPolicyHolder: {
          addfifty: '2', // 测算类型
          industrycode: this.countData.HYLX //行业code
        },
        premiumBaseDtoList //人数
      };
      let arrData = this.$lodash.cloneDeep(this.data);

      delete arrData['premiumBaseDtoList']; //投保职业人数是不参与下面的计算的
      if (param != 'TBZYa') {
        this.$bus.$emit('onRiskInfos', arrData);
      }
      if (param == 'SWCJ') {
        this.$bus.$emit('onRiskInfosSWCJ', value);
      }
      if (param == 'KZSC') {
        this.$bus.$emit('onRiskInfosKZSC', value);
      }
    },
    //测算的总价格
    cesuannum(data) {
      var a = {};
      var resultnum = 0;
      this.data.premiumBaseDtoList.forEach(e => {
        a[e.occupationKind] = e.personNum;
      });
      for (const key in a) {
        resultnum += a[key] * data[key];
      }

      return resultnum.toFixed(2);
    },
    //保费试算
    countPremiumSum(e) {
      e.preventDefault();
      let formData = this.$lodash.cloneDeep(this.data);
      if (!this.countData.YLFY) {
        formData.riskInfos = formData.riskInfos.filter(item => item.riskCode != 'accidentMedicalratio');
      }
      formData.premiumBaseDtoList = formData.premiumBaseDtoList.filter(item => {
        item.occupationKind = Number(item.occupationKind.toString().slice(0, 1));
        return item;
      });
      this.form.validateFields(err => {
        if (!err) {
          if (!this.countData.YLFY) {
            this.$message.warning('请选择意外医疗费用');
            return;
          }
          if (this.totalNumber < 5) {
            this.premiumSum = 0;
            this.$message.warning('最低投保人数5人');
            return;
          }
          if (this.exist456 && this.totalNumber < 10) {
            this.$message.warning('含4-6类职业最低投保人数10人');
            return;
          }
          this.$api.calPremiumEmployer(formData).then(res => {
            if (res.data.success) {
              let data = res.data.content;

              this.premiumSum = data;
            } else {
              this.$message.error(res.data.returnMsg + '错误');
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.policy {
  display: none;
}
.calTxt_ {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #666666;
}
.pre-box {
  margin-top: 15px;
}
.form_items {
  display: flex;
  width: 100%;
  color: #333;
  margin-bottom: 10px;
}
.risk_ {
  width: 60%;
}
.btn_list {
  margin-top: 20px;
  display: flex;
  .calBtn_ {
    margin-right: 30px;
  }
}
.flex_ {
  display: flex;
  flex-wrap: wrap;
}
.form_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #333;
  margin-bottom: 10px;
  &.width_50 {
    width: 50%;
  }
  &.width_40 {
    width: 40%;
  }
  &.width_60 {
    width: 60%;
  }
  > label {
    white-space: nowrap;
    margin-right: 10px;
    margin-top: 15px;
  }
  .right_ {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    .select_ {
      margin-top: 10px;
    }
    .check_item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-top: 10px;
      &.on {
        label {
          border-color: #fe8f2d;
        }
      }
      label {
        // border: 1px solid #d9d9d9;
        padding: 3px 10px;
        border-radius: 3px;
        margin-right: 5px;
      }
      &.s_input input {
        width: 50px;
      }
      input {
        width: 150px;
        margin-right: 5px;
      }
    }
  }
}
.p-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0;
}
</style>
